'use client'

import { Accordion, Button, Title } from '@/ui/components'
import { memo } from 'react'

interface Props {
  children: React.ReactNode
  label: string
  defaultOpen?: string
  sidenav: {
    label: string
    id: string
  }[]
}

const ReportsAccordion = ({ children, label, sidenav, defaultOpen }: Props) => (
  <div
    data-slot="reports-accordion"
    className="gap-[8.4%] xl:grid xl:grid-cols-[2fr_1fr]"
  >
    <div data-slot="reports-accordion-content">
      <Accordion.Container defaultOpen={defaultOpen}>
        {children}
      </Accordion.Container>
    </div>
    <div data-slot="reports-accordion-sidenav" className="max-xl:hidden">
      {sidenav.length > 1 && (
        <div className="top-md sticky">
          <div className="p-md ml-auto bg-neutral-200">
            <Title as="h3" className="textstyle-md-bold">
              {label}
            </Title>
            <nav>
              <ul>
                {sidenav.map((item) => (
                  <li key={item.id}>
                    <Button
                      nextLink={false}
                      variant="secondary"
                      size="s"
                      href={`#${item.id}`}
                    >
                      {item.label}
                    </Button>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      )}
    </div>
  </div>
)

export default memo(ReportsAccordion)
